import React from 'react';
import { SmileyType } from '../types';
import * as S from './styles';

type OwnProps = {
  type:
    | SmileyType.ANGRY
    | SmileyType.DISSATISFIED
    | SmileyType.NEUTRAL
    | SmileyType.SMILING
    | SmileyType.LAUGHING;
  disabled: boolean;
  size?: number;
  ariaLabel: string;
};

const RatingIcon = ({ disabled, size, type, ariaLabel }: OwnProps) => {
  switch (type) {
    case SmileyType.ANGRY:
      return <S.Angry disabled={disabled} size={size} ariaLabel={ariaLabel} />;
    case SmileyType.DISSATISFIED:
      return (
        <S.Dissatisfied disabled={disabled} size={size} ariaLabel={ariaLabel} />
      );
    case SmileyType.NEUTRAL:
      return (
        <S.Neutral disabled={disabled} size={size} ariaLabel={ariaLabel} />
      );
    case SmileyType.SMILING:
      return (
        <S.Smiling disabled={disabled} size={size} ariaLabel={ariaLabel} />
      );
    case SmileyType.LAUGHING:
      return (
        <S.Laughing disabled={disabled} size={size} ariaLabel={ariaLabel} />
      );
    default:
      return null;
  }
};

export default RatingIcon;
